<template lang="pug">
v-list.py-0
  v-list-item.scrollactive-item(:href="`#${item.slug}`" v-for="item in items")
    v-list-item-icon
      v-icon {{item.icon}}
    v-list-item-content
      h5.black--text.mb-0 {{item.title}}
</template>

<script>
export default {
  props: {
    items: Array,
  }
}
</script>